import React from "react";
import VIPCard from "../../../../../components/VIPCard";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useRecoilState, useRecoilValue } from "recoil";
import { selectedVIPTab } from "../atoms/atoms";
import { permissionsSelector } from "../../../../Login/selectors/permissionSelector";
import { VendorInvoiceTabs } from "../../VendorInvoiceTabs";

interface Props {
  count: number;
}
export const UnverifiedCaptureCard: React.FC<Props> = ({ count }) => {
  const history = useHistory();
  const [, setSelectedIndex] = useRecoilState(selectedVIPTab);
  const userPermissions = useRecoilValue(permissionsSelector);
  const currentTabs = VendorInvoiceTabs.filter((tabs) =>
    userPermissions.includes(tabs.permission)
  );
  const handleLink = () => {
    const url = "/vendortab/invoice/pending";
    history.push(url);
    const index = currentTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  return (
    <>
      <div>
        <VIPCard
          count={count}
          duration={9}
          overCount={9}
          title={"Pending/Unverified"}
          onClick={handleLink}
        />
      </div>
    </>
  );
};
